import React from "react";
import axios from "axios";
import Bloodhound from 'bloodhound-js';
import 'typeahead.js';
import $ from "jquery";
import {
    getFromLocalStorage,
    sendToLocalStorage, 
    strstr,
    removeNestedNullUndefined
} from './Utilities';

class SelectedActivity extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            "show": true
        };
    }

    handleClick = (obj) => {
        this.props.sendRemove(obj);
    }

    render(){
        if(this.state.show){
            return (
                <li className={"select2-selection__choice activity selected-activity activity-id-"+this.props.ID} type={this.props.type} 
                    data-activity-id={this.props.ID} data-brand-id={this.props.BrandID} title={this.props.Name}>
                    <span onClick={(e) => this.handleClick(this)} role="presentation">×</span> {this.props.Name}
                </li>
            );
        } else {
            return(<div></div>);
        }
    }
}

class ActivityList extends React.Component {
    static apiPromise = null; // Static variable to store API request promise
    static apiData = null; // Static variable to store resolved API data

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.state = {
            activities: null,
            allActivitiesLoaded: false,
            selected: {},
            selectedCount: 0,
            status: props.status
        };
    }

    componentDidMount() {
        // console.log(this.state.status);
        if(this.state.status === "active"){
            this.getData();      

            const parent = this;
            $(this.myRef.current).bind("typeahead:selected", function (selected, obj) {
                parent.setSelected(obj);
            });

            this.getSelected();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.allActivitiesLoaded) {
            this.createTypeahead();
        }
    }

    getData() {
        if (ActivityList.apiData) {
            // If data is already available, use it immediately
            this.setState({ activities: ActivityList.apiData, allActivitiesLoaded: true });
            this.createTypeahead();
            return;
        }

        if (!ActivityList.apiPromise) {
            // If no API request is in progress, create one
            const brandids = this.getBrandIDs();
            if (brandids.length === 0) brandids[0] = "<UmbrellaID>";

            const segmentID = $("#SegmentSelector").val() || null;
            const promises = brandids.map((id) => {
                let url = `react/process?endpoint=brand/${id}/activities&orderBy=ID+ASC&isactive=1&turnoffdebug=1`;
                if (segmentID && segmentID !== "All") url += `&segmentid=${segmentID}`;
                return axios.get(url).then((response) => response.data);
            });

            ActivityList.apiPromise = Promise.all(promises)
                .then((results) => {
                    const combinedData = results.flat();
                    ActivityList.apiData = combinedData;
                    return combinedData;
                })
                .catch((error) => {
                    console.error("Error fetching activities:", error);
                    ActivityList.apiPromise = null;
                });
        }

        // Use the shared promise to update all instances
        ActivityList.apiPromise.then((data) => {
            if (data) {
                this.setState({ activities: data, allActivitiesLoaded: true });
                this.createTypeahead();
            }
        });
    }

    getBrandIDs() {
        const filters = getFromLocalStorage("report_data");
        const brandids = [];
        if (filters && filters.ChooseBrands) {
            Object.values(filters.ChooseBrands).forEach((brand) => {
                brandids.push(brand["ID"]);
            });
        }
        return brandids;
    }

    createTypeahead() {
        $(this.myRef.current).typeahead("destroy");

        const activities = new Bloodhound({
            local: this.state.activities,
            limit: 10,
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace("Name"),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
        });

        activities.initialize();

        $(this.myRef.current).typeahead(
            { hint: true, highlight: true, minLength: 1 },
            {
                name: "activities",
                displayKey: "Name",
                multiple: true,
                templates: {
                    suggestion: function (data) {
                        return `<div class="activity" data-brand-id="${data.BrandID}" data-activity-id="${data.ID}">${data.Name}</div>`;
                    },
                },
                source: activities.ttAdapter(),
            }
        );
    }

    setSelected(obj) {
        const newlySelected = {
            type: this.props.type,
            ID: obj.ID,
            Name: obj.Name,
            BrandID: obj.BrandID,
        };
        const allSelected = { ...this.state.selected, [obj.ID]: newlySelected };

        const activities = this.state.activities.filter(
            (activity) => !(activity.ID === newlySelected.ID && activity.BrandID === newlySelected.BrandID)
        );

        if (strstr(window.location.pathname, "reports")) {
            this.props.onChange(removeNestedNullUndefined(allSelected));
        } else {
            window.ReportsCriteria.updateFilters("ChooseActivities", allSelected);
        }

        $(this.myRef.current).val("");//ensures field text clears each time
        this.setState({ activities, selected: allSelected });
        this.createTypeahead();
    }

    getSelected() {
        const filters = getFromLocalStorage("report_data");
        const type = this.props.type;
        const alreadySelected = {};

        if (filters?.ChooseActivities?.[type]) {
            Object.values(filters.ChooseActivities[type]).forEach((obj) => {
                alreadySelected[obj.ID] = {
                    type,
                    ID: obj.ID,
                    Name: obj.Name,
                    BrandID: obj.BrandID,
                };
            });
        }

        this.setState({ selected: Object.values(alreadySelected) });
    }

    removeSelected = (remove) => {
        const filters = getFromLocalStorage("report_data");
        let selected = {};

        if (filters?.ChooseActivities?.[remove.props.type]) {
            Object.values(filters.ChooseActivities[remove.props.type]).forEach((obj) => {
                if (obj.ID !== remove.props.ID) {
                    selected[obj.ID] = { type: remove.props.type, ID: obj.ID, Name: obj.Name, BrandID: obj.BrandID };
                }
            });
        }

        if (strstr(window.location.pathname, "reports")) {
            this.props.onChange(removeNestedNullUndefined(selected));
        } else {
            window.ReportsCriteria.updateFilters("ChooseActivities", selected);
        }

        this.setState({ selected: Object.values(selected), selectedCount: Object.keys(selected).length });
    };

    clearSelected() {
        if (strstr(window.location.pathname, "reports")) {
            this.props.onChange({});
        } else {
            window.ReportsCriteria.updateFilters("ChooseActivities", {});
        }

        this.setState({ selected: {}, selectedCount: 0 });
    }

    render() {
        const type = this.props.type;
        const selected = this.state.selected || {};

        if(this.state.allActivitiesLoaded){
            return (
                <div>
                    <input type="text" id="activity-selector" ref={this.myRef} style={this.props.inputStyle} />
                    {Object.keys(selected).length > 0 ? (
                        Object.entries(selected).map(([key, obj]) => (
                            <SelectedActivity
                                key={key}
                                type={type}
                                ID={obj.ID}
                                Name={obj.Name}
                                BrandID={obj.BrandID}
                                sendRemove={this.removeSelected}
                            />
                        ))
                    ) : (
                        ""
                    )}
                </div>
            );
        } else {
            return (
                <div>
                    <input type="text" id="activity-selector" ref={this.myRef} style={this.props.inputStyle} />
                    <div className="react-loading horizontal small" style={this.props.loaderStyle}></div>
                </div>
            );
        }
    }
}

ActivityList.defaultProps = {
    inputStyle: { width: "100%", height: "32px" },
    loaderStyle: { height: "32px", margin: "-31px 0 0 2px" },
};

export default ActivityList;
